export const ALL = 'all';
export const TRASH = 'trash';
export const EDIT = 'edit';
